/**
 *                                          __  __
 *    ____  ______      ______ _      __   / /_/ /_  ___  ____ ___  ___
 *   / __ \/ ___/ | /| / / __ \ | /| / /  / __/ __ \/ _ \/ __ `__ \/ _ \
 *  / / / (__  )| |/ |/ / /_/ / |/ |/ /  / /_/ / / /  __/ / / / / /  __/
 * /_/ /_/____/ |__/|__/\____/|__/|__/   \__/_/ /_/\___/_/ /_/ /_/\___/
 *
 * ns.wow WordPress theme
 * by Neidhart + Schön Group
 */

// Bundle theme module (NSTheme)
import BackToTop from "./Classes/BackToTop";
import Helper from './Classes/Helper';
import FocusHandler from './Classes/FocusHandler';
import LazyLoad from 'vanilla-lazyload';
import ResponsiveTable from "./Classes/ResponsiveTable";
import XDownloader from "./Classes/XDownloader";
import Header from "./Classes/Header";
import Home from "./Classes/Home";
import Cv from "./Classes/Cv";
import Video from "./Classes/video";
import CssHeights from "./Classes/CssHeights";
// import ScrollToTop from './Classes/ScrollToTop';
import Accordion from './Classes/Accordion';
// import AnchorScroll from "./Classes/AnchorScroll";
import ScrollToNextElement from "./Classes/ScrollToNextElement";

import Accordion3columns from "./Classes/Accordion-3columns";
import Gri from "./Classes/Gri"
import TilesHome from "./Classes/TilesHome";
// import Jump from './Classes/Jump'
// import Sticky from '../../node_modules/sticky-js';
// import YoutubeLinks from './Classes/YoutubeLinks';

var backToTopInstance = null;
var focusHandlerInstance = null;
var lazyLoadInstance = null;
var responsiveTableInstance = null;
var downloaderInstance = null;
var headerInstance = null;
var accordionInstance = null;
var jumpInstance = null;
var accordion3columns = null;
var youtubeLinksInstance = null;
var anchorContainerInstance = null;
var scrollToNextElementInstance = null;
var videoInstance = null;
var homeInstance = null;
var cssHeightsInstance = null
var cvInstance = null;
var griInstance = null;
var tilesInstance = null;
export default {

  version: () => {
    return NSContext.theme.version;
  },

  // lazyload: (givenNodeset) => {
  //   lazyLoadInstance.update(givenNodeset);
  // }

  // addYoutubeLink: (videoContainer) => {
  //   youtubeLinksInstance.addLink(videoContainer);
  // }
};
// Initialize on document ready

document.addEventListener("DOMContentLoaded", function () {
  griInstance = new Gri()
  tilesInstance = new TilesHome();
  // cssHeightsInstance = new CssHeights();
  focusHandlerInstance = new FocusHandler();
  // lazyLoadInstance = new LazyLoad();

  responsiveTableInstance = new ResponsiveTable({
    tableSelector: '.ns-table-wrap table',
    tableWrapperSelector: '.ns-table-wrap',
    breakPointLg: 1200,
    breakPointMd: 768,
    breakPointSm: 480,
    colCountNoSplit: 3,
    colCountEarlyBreak: 7,
    noSplitArray: []
  });


  // anchorContainerInstance = new AnchorScroll({
  //   containerSelector: '.ns-anchor'
  // });

  scrollToNextElementInstance = new ScrollToNextElement({
    buttonSelector: '.js-header-img-button'
  });

  /*
  Highcharts.setOptions({
    lang: {
      decimalPoint: '.', // default: '.'
      numericSymbols: ["k", "M", "G"], // default: ["k", "M", "G", "T", "P", "E"], set to null to see full numbers
      thousandsSep: '\u0020', // default: '\u0020'
      shortMonths: ["Jan", "Feb", "Mar"], // default: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    }
  });
  */


  downloaderInstance = new XDownloader({
    downloadText: "XLS", //Can be empty if you want to use an icon instead
    backgroundColor: "ffffff", //Colored Cells Background
    backgroundClass: 'ns-backgroundcolor-green', //Class of colored cells
    borderColor: '000000', //Color of border
    borderColor2: '000000',
    borderStyle: 'thin', // thin/dotted/medium/double/thick
    borderStyle2: 'medium', // thin/dotted/medium/double/thick
    headClass: 'head', //Class you want your columns based on. Will be bold in Excel
    headClass2: 'head_pdf',
    headColor: 'FFFFFF',
    boldClass: 'line_bold', //Class for Bold text in Excel
    boldClass2: 'bline_bold', //Class for Bold text in Excel
    borderClass: 'line',
    borderClass2: 'line_bold',
    borderClass3: 'ns-borderbottom-line_common_15pt_green'
  });

  headerInstance = new Header();
  homeInstance = new Home();

  backToTopInstance = new BackToTop({
    buttonClass: '.js-backtotop-toggle',
    stickyClass: '.prev-next__inner',
    fadeInPosition: 100,
    correction: 0,
    toolbarClass: '.sharing-to-top'
  });


  const img = document.querySelector('.ns-image')


  // sharingInstance = new Sharing({
  //   sharingClass: '.sharing',
  //   buttonClass: '.js-sharing-toggle'
  // });

  accordionInstance = new Accordion({
    accordions: '.ns-accordion__head'
  });

  accordion3columns = new Accordion3columns({
    accordions: '.ns-three-col-container__item'
  })

  videoInstance = new Video();
  // jumpInstance = new Jump({
  //   graphicSelector: '.ns-graphic'
  // });

  // youtubeLinksInstance = new YoutubeLinks({
  // });
  cvInstance = new Cv();
});
